import { Calendar } from "./Calendar";

export default function App() {
  return <Calendar></Calendar>;
}
